import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import preset from './default-preset/preset'
import i18n, { availableLocales, FALLBACK_LOCALE } from '@/plugins/i18n'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify)

//vuetify ships its own strings for things like the data table footer. register one for each locale we
//have, so adding a locale folder also localises the built-in component text where vuetify supports it
const vuetifyLocales = {}
availableLocales.forEach(({ code }) => {
  try {
    vuetifyLocales[code] = require('vuetify/lib/locale/' + code + '.js').default
  } catch (e) {
    //vuetify has no strings for this language, it will fall back to the default
  }
})

export default new Vuetify({
  preset,
  lang: {
    locales: vuetifyLocales,
    current: vuetifyLocales[i18n.locale] ? i18n.locale : FALLBACK_LOCALE,
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
